export const DATE_FORMAT = 'D MMM [at] HH:mm';